import { BooleanInput } from '@angular/cdk/coercion';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
    inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { UserService } from 'app/core/user/user.service';
import { AccountDrawerService } from '../../../core/services/account-drawer.service';
import { User } from '../../../interfaces/database/user.interface';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user',
    imports: [MatButtonModule, MatIconModule],
})
export class UserComponent {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;

    private _userService = inject(UserService);
    private _accountDrawer = inject(AccountDrawerService);

    get user(): User | null {
        return this._userService.user;
    }

    openDrawer(): void {
        this._accountDrawer.open();
    }
}
